import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

/** 扫描规则枚举 */
export enum ScanRule {
  /** 间隔扫描 */
  interval = 1,
  /** 定时扫描 */
  scheduled = 2
}

/** 定时触发器类型枚举 */
export enum TriggerType {
  /** 每小时 */
  hourly = 1,
  /** 每天 */
  daily = 2,
  /** 每周 */
  weekly = 3,
  /** 每月 */
  monthly = 4
}

/** 定时触发器 */
export interface UpdateTrigger {
  /** 周 */
  week: number
  /** 开始时间 */
  start_time: string
  /** 日 */
  day: number
  /** 类型：1-每小时 2-每天 3-每周 4-每月 */
  type: number
  /** 间隔规则的时候使用 */
  hour: number
}

/** 定时扫描设置 */
export interface ScanScheduleSettings {
  /** 定时扫描开关 */
  enable: boolean
  /** 代理数量 */
  agent_num?: number
  /** 扫描规则（1-间隔扫描，2-定时扫描） */
  scan_rule?: number
  /** 更新触发器 */
  update_trigger?: UpdateTrigger
}

@Injectable()
export class ScanScheduleSettingsService {
  constructor (private http: Http) {
  }

  /** 获取定时扫描设置 */
  @InvokeThrottle()
  getScanScheduleSettings () {
    return this.http.post<ScanScheduleSettings>('/client_find/timer_get', {})
  }

  /** 保存定时扫描设置 */
  @InvokeThrottle()
  saveScanScheduleSettings (data: ScanScheduleSettings) {
    return this.http.post<void>('/client_find/timer_edit', data)
  }
}

